import { AnyAction } from "redux";
import { FindById } from "../../../searchers";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";

export const FETCH_GET_SEARCHER_REQUEST = 'FETCH_GET_SEARCHER_REQUEST';
export const FETCH_GET_SEARCHER_SUCCESS = 'FETCH_GET_SEARCHER_SUCCESS';
export const FETCH_GET_SEARCHER_FAILURE = 'FETCH_GET_SEARCHER_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchGetSearcherRequest = () => {
    return {
        type: FETCH_GET_SEARCHER_REQUEST,
    };
};

const fetchGetSearcherSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_GET_SEARCHER_SUCCESS,
        payload: data
    };
};

const fetchGetSearcherFailure = (error: any) => {
    return {
        type: FETCH_GET_SEARCHER_FAILURE,
        payload: error,
    };
};

export const findById = (id: string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchGetSearcherRequest());
        try {
            const response = await FindById(id , "fields=*.*.*.*");

            console.log("responser", response);

            dispatch(fetchGetSearcherSuccess(
               response.data
            ));
        } catch (error: any) {
            dispatch(fetchGetSearcherFailure(error.message));
        }
    };
};
